import React, {useState} from 'react';
import {Button, Col, Form, Modal} from 'react-bootstrap';
import {boldTextStyles, subHeadingStyles} from "../Style";


const ManualPostalAddress = (props) => {
  const [errors, setErrors] = useState({});
    const buttonStyle = {
        backgroundColor: !props.inputValues.vehicleInputValue || props.inputValues.vehicleInputValue === '' ? '#6C757D' : '#1851A3',
        color: "white",
        paddingLeft: 25,
        paddingRight: 25,
        paddingTop: 13,
        paddingBottom: 13,
        width:"100%",
        maxWidth:"200px",
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
        borderRadius: 6,
        overflow: 'hidden',
        border: '1px white solid',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'inline-flex',
        cursor:  'pointer',
        opacity:  1
    };

    const handleClose = () => {
      setErrors({});
      const newErrors = {}
      if (!props.inputValues.addressLine1 || props.inputValues.addressLine1 === '') newErrors.addressLine1 = 'Is mandatory'


      if (!props.inputValues.suburb || props.inputValues.suburb === '') newErrors.suburb = 'Is mandatory'

      if (!props.inputValues.postcode || props.inputValues.postcode === '') newErrors.postcode = 'Is mandatory'
      setErrors(newErrors);
      if (Object.keys(newErrors).length <= 0) {
        let fullAddress = props.inputValues.addressLine1;
        if(props.inputValues.addressLine2 !== '') {
          fullAddress += ', ' + props.inputValues.addressLine2;
        }
        fullAddress += ', '+props.inputValues.suburb + ', '+ props.inputValues.postcode
        props.handleChangeValue('full_address', fullAddress);
        props.setParentManualAddressPopupShow(false);
        props.callAddressSearch(props.inputValues.addressLine1,props.inputValues.addressLine2, props.inputValues.suburb, props.inputValues.postcode );
      }
    };

    const close = () => {
        props.setParentManualAddressPopupShow(false);
    };

    return (
        <>
            <Modal
                show={props.parentManualAddressPopupShow}
                onHide={close}

                backdrop="static"
                size="lg"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title style={subHeadingStyles}>Enter Address Manually</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row" style={boldTextStyles}>
                        <Form.Group as={Col} md="4" className="form-group required">
                            <Form.Label className='formHeader'>Address Line 1</Form.Label>
                            <Form.Control required type="search" id='address_line_1'
                                name='addressLine1'
                                value={props.inputValues.addressLine1}
                                onChange={props.handleChange}
                                          isInvalid={!!errors.addressLine1}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.addressLine1}
                            </Form.Control.Feedback>
                        </Form.Group><Col md="1" />
                        <Form.Group as={Col} md="4">
                            <Form.Label>Address Line 2</Form.Label>
                            <Form.Control
                                name="addressLine2"
                                value={props.inputValues.addressLine2}
                                onChange={props.handleChange}
                            />
                        </Form.Group><Col md="1" />
                        <Form.Group as={Col} md="4" className="form-group required">
                            <Form.Label>Suburb</Form.Label>
                            <Form.Control required
                                name="suburb"
                                value={props.inputValues.suburb}
                                onChange={props.handleChange}
                                          isInvalid={!!errors.suburb}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.suburb}
                            </Form.Control.Feedback>
                        </Form.Group><Col md="1" />
                      <Form.Group as={Col} md="4" className="form-group">
                            <Form.Label>City</Form.Label>
                        <Form.Control
                                name="city"
                                value={props.inputValues.city}
                                onChange={props.handleChange}
                            />
                        </Form.Group><Col md="1" />
                        <Form.Group as={Col} md="4" className="form-group required">
                            <Form.Label>Postcode</Form.Label>
                            <Form.Control required
                                name="postcode"
                                value={props.inputValues.postcode}
                                onChange={props.handleChange}
                                          isInvalid={!!errors.postcode}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.postcode}
                            </Form.Control.Feedback>
                        </Form.Group><Col md="1" />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' style={buttonStyle} onClick={handleClose}>
                        Use this address
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )

}

export default ManualPostalAddress;
